import { render, staticRenderFns } from "./CampaignMessageModal.html?vue&type=template&id=e65b58b4&scoped=true&external"
import script from "./CampaignMessageModal.js?vue&type=script&lang=js&external"
export * from "./CampaignMessageModal.js?vue&type=script&lang=js&external"
import style0 from "./CampaignMessageModal.scss?vue&type=style&index=0&id=e65b58b4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65b58b4",
  null
  
)

export default component.exports